// extracted by mini-css-extract-plugin
export default {"modal-inner":"modal-inner__Zz8t_"};